import { FaqItem } from '../types/content';

export const faqItems: FaqItem[] = [
  {
    id: 'what-counts',
    question: 'What counts as an agent?',
    paragraphs: [
      ['We count three tiers. ', 'Created agents', ' are deliberately built by someone and appear in a registry, store, or scan — Custom GPTs, Character.AI characters, Copilot Studio agents, ERC-8004 identities.'],
      ['Device-embedded assistants', ' are counted as one endpoint per active device, because each maintains its own context, permissions and ability to act. Apple alone reports 2.5B active devices', { ref: 'appleinsider' }, '.'],
      ['Ambient IoT', ' covers connected devices that act on their environment without a human in the loop — 21.1B worldwide', { ref: 'iotanalytics' }, '. Hence three scenarios, never one headline number.'],
      ['Per-country estimates allocate the global totals: assistant endpoints = population × min(mobile subscriptions per 100, 100) ÷ 100 × 0.82, using the smartphone share of mobile connections', { ref: 'gsma', estimate: { low: '0.78', high: '0.86' } }, '. Created agents are allocated by each country’s share of internet users.'],
    ],
  },
  {
    id: 'why-ranges',
    question: 'Why ranges instead of single numbers?',
    paragraphs: [
      ['Because registered ≠ active. Moltbook lists 2.92M registered agents but only ~46.7k active posters', { ref: 'arxivMoltbook' }, '.'],
      ['ERC-8004 counts 549,841 registered identities, yet only 67 carry service records', { ref: 'arxivErc' }, '. Every range on this site spans that gap between what is registered and what demonstrably runs.'],
    ],
  },
  {
    id: 'human-data',
    question: 'Where does the human data come from?',
    paragraphs: [
      ['World population and its rate of change: Worldometer’s UN-based clock', { ref: 'worldometer' }, '. Internet, smartphone and GenAI adoption: DataReportal', { ref: 'datareportal' }, '.'],
      ['Country indicators are fetched live from the World Bank API', { ref: 'wbInternet' }, ' and country metadata from REST Countries', { ref: 'restcountries' }, '. Median age comes from UN World Population Prospects 2024', { ref: 'unwpp' }, ', embedded because the World Bank does not publish it.'],
    ],
  },
  {
    id: 'known-gaps',
    question: 'What are the known gaps?',
    paragraphs: [
      ['Enterprise instances: vendors report deals and conversations, not agent counts', { ref: 'salesforce' }, '. Dormant registrations inflate every registry. Firewall-hidden self-hosts are invisible to scanners — the 312k exposed OpenClaw instances are a floor, not a census', { ref: 'bitsight' }, '.'],
      ['Sub-agent fan-out — one agent spawning many short-lived workers — is invisible to every census method we know of. Our "other assistants" figure (Bixby, Copilot, TV, automotive) is a labeled Fermi estimate and the weakest number in the model.'],
    ],
  },
  {
    id: 'accuracy',
    question: 'How accurate is this?',
    paragraphs: [
      ['Every figure is either a dated public measurement or a labeled Fermi assumption with an explicit range. Live counters extrapolate from a dated base at a stated rate; machine rates are our assumption', { ref: 'fermi', estimate: { low: '0.5×', high: '2×' } }, '.'],
      ['Compiled Oct 5, 2026. This domain moves by roughly an order of magnitude per quarter — treat any figure older than 90 days as historical.'],
    ],
  },
];
